import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { UserCategory } from 'src/app/core/models/core.models';
import { PostUserCategoriesEditorService } from 'src/app/core/services/post-user-categories-editor.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CategoryComponent {
  @Input() category!: UserCategory;
  @Input() categoryForm!: FormGroup;

  private readonly editor = inject(PostUserCategoriesEditorService);

  get isSelectedControl(): FormControl {
    return this.categoryForm.get('isSelected') as FormControl;
  }

  onCheckboxChange(isSelected: boolean) {
    this.editor.toggleSelection(
      this.category.company_category_id,
      this.category.id,
      isSelected,
    );
    // Additional logic if needed when a checkbox changes
    this.categoryForm.markAsDirty();
  }
}
